<template>
    <div class="box">
        <!-- 居中显示一段文字，id和id对应的title -->
        <div style="text-align: center; font-size: .8rem;">
            {{$route.query.id}} - {{titleData[$route.query.type][$route.query.id]}}
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {bookList} from '@/api/api';

@Options({
    components: {
    },
    created() {
        if (!this.$route.query.id) {
            this.gotoHome();
            return;
        }
        this.bookList();
    }
})

export default class AnswerList extends Vue {
    bookData = [];

    titleData= {
        duben: {
            1: 'L1-U1-W1-1	Red and Blue 	红色和蓝色',
            2: 'L1-U1-W1-2	Let\'s Draw!	一起画！',
            3: 'L1-U1-W1-3	Fruit Colours	水果的颜色',
            4: 'L1-U1-W2-1	It\'s Colourful	五彩斑斓！',
            5: 'L1-U1-W2-2	Making Colours	混合颜色',
            6: 'L1-U1-W2-3	Nature Colours	大自然的颜色',
            7: 'L1-U1-W3-1	I Like Brown!	我喜欢棕色！',
            8: 'L1-U1-W3-2	Colourful Birds	五颜六色的小鸟',
            9: 'L1-U1-W3-3	Black and White	黑与白',
            10: 'L1-U1-W4-1	An Apple Tree	一棵苹果树	',
            11: 'L1-U1-W4-2	My back!	盒子里的蚂蚁	',
            12: 'L1-U1-W4-3	B and C	B和C	',
            13: 'L1-U2-W1-1	It\'s a Book!需要改标题	这是一本书！	',
            14: 'L1-U2-W1-2	Go To School	去上学	',
            15: 'L1-U2-W1-3	In the Classroom	教室里	',
            16: 'L1-U2-W2-1	What\'s that?	那是什么？	',
            17: 'L1-U2-W2-2	Stop!	停下！	',
            18: 'L1-U2-W2-3	What\'s this?	这是什么？	',
            19: 'L1-U2-W3-1	Where\'s My Chair?	我的椅子在哪里？	',
            20: 'L1-U2-W3-2	We Like It	我们喜欢它	',
            21: 'L1-U2-W3-3	Look, a Sun	看，一个太阳	',
            22: 'L1-U2-W4-1	Egg is Yummy!	鸡蛋真美味！	',
            23: 'L1-U2-W4-2	Four Feet	四只脚	',
            24: 'L1-U2-W4-3	D and E	D和E	',
            25: 'L1-U3-W1-1	It\'s a Goat	它是只山羊	',
            26: 'L1-U3-W1-2	Here Comes a Train	小火车来啦	',
            27: 'L1-U3-W1-3	Baby Animals	动物宝宝	',
            28: 'L1-U3-W2-1	A Magic Man	一个魔术师	',
            29: 'L1-U3-W2-2	At the Farm	在农场	',
            30: 'L1-U3-W2-3	Animals Help	动物帮忙	',
            31: 'L1-U3-W3-1	What Is It?	"它是什么？中文标题更改"',
            32: 'L1-U3-W3-2	A Pet Show	宠物秀	',
            33: 'L1-U3-W3-3	I Like Animals	我喜欢动物	',
            34: 'L1-U3-W4-1	I Like the Gift	我喜欢这个礼物	',
            35: 'L1-U3-W4-2	Go for a Drive	去兜风	',
            36: 'L1-U3-W4-3	H and I	H和I	',
        },
        lianxice: {

            1: 'Unit 1 Week 1 核心知识点',
            2: 'Unit 1 Week 1 Chant',
            3: 'U1-W1-L1-听力题',
            4: 'U1-W1-L2-听力题',
            5: 'Unit 1 Week 2 核心知识点',
            6: 'Unit 1 Week 2 Chant',
            7: 'U1-W2-L1-听力题',
            8: 'U1-W2-L2-听力题',
            9: 'Unit 1 Week 3 核心知识点',
            10: 'Unit 1 Week 3 Chant	',
            11: 'U1-W3-L1-听力题	',
            12: 'U1-W3-L2-听力题	',
            13: 'Unit 1 Week 4 核心知识点	',
            14: 'Unit 1 Week 4 Chant	',
            15: 'U1-W4-L1-听力题	',
            16: 'U1-W4-L2-听力题	',
            17: 'U1-Unit Check 听力题1	',
            18: 'U1-Unit Check 听力题2	',
            19: 'Unit 2 Week 1 核心知识点	',
            20: 'Unit 2 Week 1 Chant	',
            21: 'U2-W1-L1-听力题	',
            22: 'U2-W1-L2-听力题	',
            23: 'Unit 2 Week 2 核心知识点	',
            24: 'Unit 2 Week 2 Chant	',
            25: 'U2-W2-L1-听力题	',
            26: 'U2-W2-L2-听力题	',
            27: 'Unit 2 Week 3 核心知识点	',
            28: 'Unit 2 Week 3 Chant	',
            29: 'U2-W3-L1-听力题	',
            30: 'U2-W3-L2-听力题	',
            31: 'Unit 2 Week 4 核心知识点	',
            32: 'Unit 2 Week 4 Chant	',
            33: 'U2-W4-L1-听力题	',
            34: 'U2-W4-L2-听力题	',
            35: 'U2-Unit Check 听力题1	',
            36: 'U2-Unit Check 听力题2	',
            37: 'Unit 3 Week 1 核心知识点	',
            38: 'Unit 3 Week 1 Chant	',
            39: 'U3-W1-L1-听力题	',
            40: 'U3-W1-L2-听力题	',
            41: 'Unit 3 Week 2 核心知识点	',
            42: 'Unit 3 Week 2 Chant	',
            43: 'U3-W2-L1-听力题	',
            44: 'U3-W2-L2-听力题	',
            45: 'Unit 3 Week 3 核心知识点	',
            46: 'Unit 3 Week 3 Chant	',
            47: 'U3-W3-L1-听力题	',
            48: 'U3-W3-L2-听力题	',
            49: 'Unit 3 Week 4 核心知识点	',
            50: 'Unit 3 Week 4 Chant	',
            51: 'U3-W4-L1-听力题	',
            52: 'U3-W4-L2-听力题	',
            53: 'U3-Unit Check 听力题1	',
            54: 'U3-Unit Check 听力题2	',

        },
        daan: {
            1: 'L1-U1～U3-学习手册-答案'
        }
    };

    async bookList() {
        const res = await bookList({
            bookParam: this.$route.query.id
        });
        if (res.code === '0') {
            this.bookData = res.data?.list;
        }
        else {
            this.$toast(res.msg);
        }
    }

    gotoHome() {
        this.$router.replace({
            path: '/answerList'
        });
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100vw;
    min-height: 100vh;
    padding-top: .43rem;

    .home {
        width: 1.17rem;
        height: 1.17rem;
        position: fixed;
        top: 0;
        right: .24rem;
    }

    &-list {
        width: 100%;
        padding-left: .48rem;
        padding-bottom: .64rem;
        box-sizing: border-box;
        &-title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: .4rem;
            color: #0B0B0B;
            line-height: .51rem;
            text-align: left;
            font-style: normal;
            margin-bottom: .32rem;
        }
        &-name {
            width: 9.15rem;
            padding: .4rem;
            border-radius: .32rem;
            border: .01rem solid #F1F1F1;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: .4rem;
            color: #333333;
            line-height: .61rem;
            text-align: left;
            font-style: normal;
            box-sizing: border-box;
        }
        &-imgbox {
            width: 9.15rem;
            padding: .4rem;
            border-radius: .32rem;
            border: .01rem solid #F1F1F1;
            box-sizing: border-box;
                .img {
                width: 8.35rem;
            }
        }
    }
}

</style>
